import { render, staticRenderFns } from "./GenAICommentarySection.vue?vue&type=template&id=94278766&scoped=true"
import script from "./GenAICommentarySection.vue?vue&type=script&lang=js"
export * from "./GenAICommentarySection.vue?vue&type=script&lang=js"
import style0 from "./GenAICommentarySection.vue?vue&type=style&index=0&id=94278766&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94278766",
  null
  
)

export default component.exports